import { makeStyles } from '@material-ui/core';


export const radiogroupStyles = makeStyles((theme) => ({
    radiogroup_details: {
        display: 'flex',
        gap: theme.spacing(1),
        'align-items': 'flex-start',
        marginBottom: theme.spacing(2),
    },    
}));
